import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';

const Hero = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('prenota');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-[#222222]/75 z-10" />

      {/* Art Deco Pattern */}
      <div className="art-deco-pattern z-20" />

      {/* Content */}
      <div className="relative z-30 text-center px-4 max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p
            className="text-xs md:text-sm uppercase tracking-[0.2em] text-[#FFDA00] mb-6 font-semibold"
            data-testid="hero-subtitle"
          >
            Food & Lounge
          </p>
          <h1
            className="text-5xl md:text-7xl lg:text-8xl font-bold leading-none mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="hero-title"
          >
            Rov<span className="text-[#FFDA00]">è</span>scio
          </h1>
          <p
            className="text-lg md:text-xl text-gray-300 mb-4 max-w-2xl mx-auto"
            data-testid="hero-description"
          >
            Vivi l'esperienza culinaria italiana con stile Art Deco.
            <br />
            Eleganza, gusto e atmosfera unica a Roma, in Via Eschilo 85.
          </p>
          <p className="text-sm md:text-base text-[#FFDA00] mb-12 uppercase tracking-wider">
            #VIVIALROVESCIO
          </p>

          <motion.button
            onClick={scrollToBooking}
            className="btn-primary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            data-testid="hero-cta-button"
          >
            Prenota Ora
          </motion.button>
        </motion.div>

        <motion.div
          className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.8, repeat: Infinity, repeatType: 'reverse' }}
        >
          <ArrowDown className="text-[#FFDA00]" size={32} />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
